<template>
    <div class="meetingRoomPopover">
        <div class="meetingRoomPopoverHead">
            <i class="el-icon-close cursor-p" @click="close"></i>
        </div>
        <div class="meetingRoomPopoverBody">
            <p class="icon-text">
                <i class="icon"
                    ><span
                        class="dot"
                        :class="[
                            status == 1
                                ? 'dot-green'
                                : status == 5
                                ? 'dot-orange'
                                : 'dot-gray'
                        ]"
                    ></span
                ></i>
                <span class="text">{{ data.title }}</span>
            </p>
            <p class="icon-text">
                <i class="el-icon-time icon"></i>
                <span class="text">{{ data.date }}</span>
            </p>
            <p class="icon-text">
                <i class="el-icon-location-outline icon"></i>
                <span class="text">{{ data.room }}</span>
            </p>
            <p class="icon-text">
                <i class="el-icon-user icon"></i>
                <span class="text">{{ data.user_name }}</span>
            </p>
        </div>
        <div class="meetingRoomPopoverFoot"></div>
    </div>
</template>

<script>
export default {
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        data: {
            type: Object,
            default: () => {}
        },
        status: {
            type: [Number, String],
            default: ""
        }
    },
    methods: {
        close() {
            this.$emit("update:visible", false);
        }
    }
};
</script>

<style lang="scss" scoped>
.meetingRoomPopover {
    .meetingRoomPopoverHead {
        text-align: right;
        position: absolute;
        width: 95%;
    }
    .meetingRoomPopoverBody {
        padding: 5px 10px;
        /* .title {
            display: flex;
            align-items: center; */
        .dot {
            display: inline-block;
            min-width: 12px;
            min-height: 12px;
            border-radius: 50%;
        }
        .dot-green {
            background: #00b853;
        }
        .dot-orange {
            background: $theme-color;
        }
        .dot-gray {
            background: #dddede;
        }
        // }
        .icon-text {
            display: flex;
            align-items: center;
            margin-top: 10px;
            .icon {
                margin-right: 10px;
                font-size: 20px;
                width: 20px;
            }
            .text {
            }
        }
    }
    .cursor-p {
        cursor: pointer;
    }
}
</style>
